import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/packages/ui/src/layouts/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/packages/ui/src/ui/avatar.tsx");
